// removed by extract-text-webpack-plugin
module.exports = {"HeroVideoWrapper":"_1KoXYa_q6rl-7gbBGUH2Ei","HeroVideoWrapper-Content":"_1RS_90B0dup_SQK4mAhlae","HeroVideo":"_2MrPpDd0X0Ew2IRnEp-nuM","HeroVideo-Content":"_2xgdFDjz5nGOeK8R0TRNGT","Title":"_2qm85nFAXoD9Mfzr10fUWq","SubTitle":"_1D1Pk7YFtbpHXhkwFHpDDp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/HeroVideo/HeroVideo.css
// module id = 297
// module chunks = 8